const BlogData = [
  {
    id: 1,
    title: "5 Tips for Keeping Your Home Clean and Fresh",
    date: "January 8, 2025",
    shortDescription: "Keeping your home clean doesn’t have to be overwhelming",
    description:
      "Keeping your home clean doesn’t have to be overwhelming. Discover practical tips for maintaining a fresh and tidy space effortlessly.",
    image: "https://cleanmyplace.in/assets/img/services/1.jpg",
    secondImage:
      "https://5.imimg.com/data5/SELLER/Default/2022/9/ZH/IN/GN/157744220/industrial-deep-cleaning-services-500x500.jpg",
    author: "John Doe",
    benifits: [
      "1. Regular Cleaning: Schedule regular cleaning to keep your home spotless and clean.",
      "2. Vacuum Regularly: Vacuum your home regularly to remove dust and debris.",
      "3. Use a Dusting Brush: Use a dusting brush to remove dust from surfaces.",
      "4. Use a Vacuum Cleaner: Use a vacuum cleaner to remove dirt and debris from your home.",
      "5. Use a Mop: Use a mop to clean hard-to-reach corners and surfaces.",
    ],
    nonInclusions: [
      "100% stain removal cannot be guaranteed.",
      "Achieved Gloss levels would depend on the existing condition of floor.",
      "An obstruction free surface is required for carrying out the process.",
      "Beds or other very heavy furniture will not be moved to restore the floor underneath.",
    ],
  },
  {
    id: 2,
    title: "Top 10 Plants to Purify Air at Home",
    date: "February 12, 2025",
    shortDescription: "Bring nature indoors with these air-purifying plants",
    description:
      "Discover the best air-purifying plants to improve indoor air quality and create a refreshing environment at home. From snake plants to peace lilies, explore how these plants can benefit your living space.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZQAo3Vg1NOnNytYpCJc2sHmKyLpdvfQpiJ-KwnLecZqM34hgdPuS8AcqtgS8efl-hH6E&usqp=CAU",
    secondImage:
      "https://img.staticmb.com/mbcontent/images/crop/uploads/2023/2/air-purifying-plants_0_1200.jpg",
    author: "Jane Smith",
    benifits: [
      "1. Natural air purification.",
      "2. Improved humidity levels.",
      "3. Enhanced aesthetic appeal.",
      "4. Reduced stress and improved mental health.",
      "5. Low maintenance requirements.",
    ],
    nonInclusions: [
      "Pet-friendly options may vary.",
      "Requires adequate sunlight for growth.",
      "Regular watering is necessary.",
      "May not thrive in extreme climates.",
    ],
  },
  {
    id: 3,
    title: "How to Organize Your Workspace for Maximum Productivity",
    date: "March 5, 2025",
    shortDescription: "Boost your productivity with an organized workspace",
    description:
      "Transform your workspace into a productivity hub with these organization tips. From decluttering to setting up ergonomic furniture, learn how to work smarter.",
    image:
      "https://blog-cdn.everhour.com/blog/wp-content/uploads/2021/05/home-office-organization.jpg",
    secondImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSN6XQEGeJcDKOQzFb8qXhBAWkv-y4JDr_-_iKbuvzrQXwnu64w2NtFrkiYCIi2lTVsrKU&usqp=CAU",
    author: "Mark Johnson",
    benifits: [
      "1. Reduced stress through decluttering.",
      "2. Improved focus and efficiency.",
      "3. Enhanced comfort with ergonomic setups.",
      "4. Easy access to important tools and documents.",
      "5. Professional appearance for virtual meetings.",
    ],
    nonInclusions: [
      "Customized furniture not included.",
      "Does not guarantee increased motivation.",
      "Requires consistent effort to maintain.",
      "Not suitable for shared workspaces.",
    ],
  },
  {
    id: 4,
    title: "Keep Alive Your Sofa Look, Try On Ways To Clean Sofa At Home",
    date: "April 18, 2025",
    shortDescription: "Adopt eco-friendly habits for a better tomorrow",
    description:
      "Learn how to lead a sustainable lifestyle with easy-to-implement steps. From reducing waste to conserving energy, discover ways to live responsibly.",
    image:
      "https://blog.woodenstreet.com/images/data/image_upload/1648277378sofa-cleaning-at-home-banner%20(1).png",
    secondImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjsIosFxeSuJ7i0aw8-DwS0JYmvxaKhfPJKw&s",
    author: "Emily Davis",
    benifits: [
      "1. Reduced carbon footprint.",
      "2. Cost savings on utilities.",
      "3. Healthier living environment.",
      "4. Contribution to environmental preservation.",
      "5. Enhanced community engagement.",
    ],
    nonInclusions: [
      "Initial investments may be required.",
      "Not all actions may yield immediate results.",
      "Requires a mindset shift.",
      "May involve lifestyle adjustments.",
    ],
  },
  {
    id: 5,
    title: "The Ultimate Guide to Spring Cleaning",
    date: "May 10, 2025",
    shortDescription: "Revitalize your home with thorough spring cleaning",
    description:
      "Tackle your spring cleaning like a pro with this ultimate guide. From decluttering to deep cleaning, learn how to refresh your living space for the new season.",
    image:
      "https://glassguard.co.nz/cdn/shop/articles/The_Ultimate_Guide_How_to_Spring_Clean_Step-By-Step_10_Pro_Guidelines_1200x_59544a7f-1e1d-4f5d-ad51-085afac32a29_1200x.png?v=1726002167",
    secondImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbK_VxxKrmkkl-qkmzduJJW6ygrHs3K68VOz2PgLmaKrG42AoOSlSgw20JYvc6kJgBQEE&usqp=CAU",
    author: "Sophia Wilson",
    benifits: [
      "1. Fresh and revitalized living space.",
      "2. Improved organization and functionality.",
      "3. Elimination of allergens and dust.",
      "4. Sense of accomplishment and satisfaction.",
      "5. Opportunity to donate unused items.",
    ],
    nonInclusions: [
      "Does not include professional cleaning services.",
      "Results depend on individual effort.",
      "May require multiple days for larger homes.",
      "Specialized tools not provided.",
    ],
  },
  {
    "id": 6,
    "title": "Professional Cleaning Service – The Right Investment in Cleaning Your Residential and Commercial Property",
    "date": "June 22, 2025",
    "shortDescription": "Maintaining a clean and hygienic environment is crucial for both residential and commercial premises.",
    "description": "In today’s fast-paced world, keeping your residential and commercial properties clean and well-maintained can be a daunting task. This is where professional cleaning services come to the rescue, providing a comprehensive solution to all your cleaning needs. Whether it’s a sparkling living room, a spotless bathroom, or a pristine office space, professional cleaners offer unmatched expertise and efficiency.\n\nInvesting in professional cleaning is more than just hiring someone to tidy up. It’s about ensuring that every nook and corner is thoroughly cleaned and sanitized, promoting a healthier environment for your family, employees, and clients. Professional services use advanced equipment and eco-friendly cleaning products to deliver high-quality results. They are well-trained to handle even the toughest stains and dirt, ensuring your property always looks its best.\n\nFor commercial properties, a clean workplace not only boosts employee morale but also leaves a positive impression on clients and visitors.",
    "image": "https://www.bookingpressplugin.com/wp-content/uploads/2023/12/bpa_css_hero_sec_main_image.webp",
    "secondImage": "https://wallpaperaccess.com/full/5807032.jpg",
    "author": "Oliver Brown",
    "benifits": [
      "1. Saves time and effort for property owners.",
      "2. Ensures a hygienic and sanitized environment.",
      "3. Enhances the aesthetic appeal of your property.",
      "4. Increases the longevity of furniture and fixtures.",
      "5. Offers customized cleaning solutions for different needs."
    ],
    "nonInclusions": [
      "Does not include maintenance or repair services.",
      "Cleaning supplies are not always provided by the service.",
      "Availability may vary based on location.",
      "Does not cover pest control or deep structural cleaning."
    ]
  }  
];
export default BlogData;


